import React from 'react';
import DashboardLayout from '../DashboardLayout';

const PurchaseLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default PurchaseLayout;
